var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"color":"primary","icon":"","small":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleWishlist.apply(null, arguments)}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }